import React, {isValidElement} from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';
import ModalSimple from '../../../global/modal-simple';

declare const closeAllModals: () => void;

interface ILineCustomProps {
    id: number;
    modalId: string;
}

@observer
class ModalInfo extends React.Component<ILineCustomProps> {
    @observable epTitle: string;
    @observable ep1: string;
    @observable ep2: string;
    @observable ep3: string;
    @observable ep4: string;
    @observable ep5: string;
    @observable ep6: string;
    @observable ep7: string;
    @observable ep8: string;
    @observable ep9: string;
    @observable ep10: string;

    constructor(props) {
        super(props);
        this.setup = this.setup.bind(this);
        this.save = this.save.bind(this);
        this.setup();
        makeObservable(this);
    }

    @action
    setup = () => {
        const item = store.checkout.cart.items.filter(o => o.id === this.props.id)[0];
        this.ep1 = item.ep1;
        this.ep2 = item.ep2;
        this.ep3 = item.ep3;
        this.ep4 = item.ep4;
        this.ep5 = item.ep5;
        this.ep6 = item.ep6;
        this.ep7 = item.ep7;
        this.ep8 = item.ep8;
        this.ep9 = item.ep9;
        this.ep10 = item.ep10;

        this.epTitle = item.epTitle;
    };

    @action
    save = async (e: any) => {
        const item = store.checkout.cart.items.filter(o => o.id === this.props.id)[0];
        item.ep1 = this.ep1;
        item.ep2 = this.ep2;
        item.ep3 = this.ep3;
        item.ep4 = this.ep4;
        item.ep5 = this.ep5;
        item.ep6 = this.ep6;
        item.ep7 = this.ep7;
        item.ep8 = this.ep8;
        item.ep9 = this.ep9;
        item.ep10 = this.ep10;

        const success = await checkout('line-ep-save');
        closeAllModals();
    };

    render() {
        return (
            <div
                className="modal"
                tabIndex={-1}
                id={this.props.modalId}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            Edit Engraved Plate
                            <button
                                type="button"
                                className="btn-close"
                                data-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-label">Engraved Plate Line 1</div>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={this.ep1}
                                    onChange={e => (this.ep1 = e.target.value)}
                                    maxLength={30}
                                />
                            </div>
                            <div className="form-label pad-top">Engraved Plate Line 2</div>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={this.ep2}
                                    onChange={e => (this.ep2 = e.target.value)}
                                    maxLength={30}
                                />
                            </div>
                            <div className="form-label pad-top">Engraved Plate Line 3</div>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={this.ep3}
                                    onChange={e => (this.ep3 = e.target.value)}
                                    maxLength={30}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={this.save}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ModalInfo;
